import { ActivityStatus, ActivityType } from "generated-graphql/graphql";

type WorkflowActivity = {
  type: string;
  description?: string | null;
  status: string;
};

/**
 * Determines if a workflow has a pending Lob check activity.
 *
 * Lob check activities always start with "Check" (e.g. "Check", "Check to Potter County LEPC").
 * This convention is enforced by BaseSendLobCheckActivityHandler's constructor.
 * Lob mail activities use "Mail to ..." prefixes and should NOT match.
 *
 * Used to suppress the "Make or Record a Payment" button on staff activities
 * that have a downstream Lob check handling the payment.
 */
export function hasPendingLobCheckActivity(
  activities: readonly WorkflowActivity[] | undefined | null
): boolean {
  return (
    activities?.some(
      (activity) =>
        activity.type === ActivityType.Lob &&
        activity.description?.startsWith("Check") &&
        activity.status === ActivityStatus.NotStarted
    ) ?? false
  );
}
